import { useMutation } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { testClaimQuest } from '..';
export const useTestClaimQuest = ({ tasks, questId, subdomain = getSubdomain(), }) => {
    return useMutation({
        mutationFn: testClaimQuest(subdomain, questId, tasks),
    });
};
